import React from "react";
import {
  Answer,
  Heading,
  PageWrapper,
  Paragraph,
  PlusButton,
  QAWrapper,
  Question,
} from "./PagesStyles";
import {
  Parah,
  PointsIcon,
  PointsWrapper,
  ThirdTitle,
} from "../Contents/ContentsStyles";
import { Navbar } from "../Components";

const BrandedPolicy = () => {
  return (
    <PageWrapper>
      <Navbar />
      <Heading>Branded Content Policy</Heading>
      <Paragraph>
        Branded content on Talents Explore (“Branded Content”) is content that
        promotes goods or services where you will receive (or have already
        received) something of value from a third party, such as a brand, in
        exchange for your post, or which you might otherwise need to disclose to
        comply with laws or regulations. Branded Content could include content
        posted by you, which features or
      </Paragraph>
      <QAWrapper>
        <ThirdTitle>References:</ThirdTitle>
        <PointsWrapper className="gap: 2rem">
          <PointsIcon />
          <div className="margin-left: 1rem">
            A product or service that has been gifted to you by a brand, or that
            you have been paid to post about (whether in the form of money or a
            gift), or for which you will receive a commission on any sales (for
            instance, via an affiliate link or using a promotional code); or
          </div>
        </PointsWrapper>
        <PointsWrapper className="gap: 2rem">
          <PointsIcon /> A brand that you have or have had a commercial
          relationship with, such as where you are acting as a brand ambassador.
        </PointsWrapper>
      </QAWrapper>

      <QAWrapper>
        <Question style={{ background: "var(--l-gray)", cursor: "default" }}>
          Rules for posting Branded Content:
          <PlusButton />
        </Question>

        <Answer>
          <Parah>
            You are responsible for ensuring that any Branded Content that you
            post complies with all applicable laws and regulations. While the
            rules in this Branded Content Policy are intended to help you to
            comply with relevant laws and regulations, they are not exhaustive
            and you should be aware of any other applicable legal requirements.
          </Parah>

          <Parah>
            As well as following these rules when you post Branded Content, you
            must also comply with Talents Explore’s Terms of Service and
            Community Guidelines.
          </Parah>

          <Parah>What do you need to do when you post Branded Content?</Parah>

          <PointsWrapper>
            <Parah>
              <PointsIcon /> You must enable the branded content toggle when
              posting Branded Content (unless you are located in a country where
              it is not available).
            </Parah>
          </PointsWrapper>
          <PointsWrapper>
            <Parah>
              <PointsIcon /> You must ensure that the product or service you are
              promoting is sufficiently clear, without requiring other users to
              access your profile page or any links. For instance, you should
              explicitly identify the product or service verbally and/or in the
              text caption.
            </Parah>
          </PointsWrapper>
          <PointsWrapper>
            <Parah>
              <PointsIcon /> You must not post Branded Content which promotes
              products or services relating to any of the 🚫Prohibited
              Industries listed below.
            </Parah>
          </PointsWrapper>
          <PointsWrapper>
            <Parah>
              <PointsIcon /> We also recommend that you do not post Branded
              Content that violates any of the Country-Specific Requirements
              available via the link below. Otherwise, we may be required to
              prevent the content from being accessed in a specific country or
              countries where it may be contrary to local laws or regulations.
            </Parah>
          </PointsWrapper>
          <Parah>
            To the extent that your Branded Content does not comply with these
            rules, we may remove the content or impose other restrictions.
          </Parah>
          <Parah>
            We may update these rules periodically (for instance, if we need to
            reflect any changes to applicable laws or regulations) and in some
            instances we may need to apply them to content you have already
            posted (for example, if a new law requires us to no longer display
            certain types of content).
          </Parah>
        </Answer>
      </QAWrapper>

      <QAWrapper>
        <Question style={{ background: "var(--l-gray)", cursor: "default" }}>
          Prohibited Industries <PlusButton />
        </Question>

        <Answer>
          <Parah>
            You must not post Branded Content which promotes products or
            services from the following 🚫 Prohibited Industries.
          </Parah>
          <Parah>
            🚫 Alcohol - Alcoholic beverages (wine, beer, spirits, etc.),
            alcohol clubs/subscription services, alcohol-making kits, or
            alcohol-sponsored events. This includes alcohol-free or no-alcohol
            alternatives and soft drinks presented as mixers for alcohol.
          </Parah>
          <Parah>
            🚫 Cigarettes and tobacco products - Cigarettes, cigars, tobacco, e
            cigarettes, cigarette containers, shisha, and other related products
            and services.
          </Parah>

          <Parah>
            🚫 Drug-related products and services - Illegal drugs, drug
            paraphernalia, recreational and prescription drugs, CBD supplements.
          </Parah>

          <Parah>
            🚫 Weapons - Dangerous weapons, including guns, explosives, knives,
            swords, and other objects that are designed to cause harm to
            individuals.
          </Parah>

          <Parah>
            🚫 Gambling - Online gambling, casinos, sports betting, and Branded
            Content promoting fantasy sports, bingo, lotteries, or other
            gambling related content.
          </Parah>

          <Parah>
            🚫 Sexual products and services - Adult entertainment and related
            paraphernalia including pornography, sex toys, lubricants, and
            fetish costumes, including some underwear like corsets and
            micro-thongs.
          </Parah>

          <Parah>
            🚫 Political content - Referencing, promoting, or opposing, a
            candidate for public office, current or former political leader,
            political party, or political organization. You must not advocate a
            stance (for or against) on a local, regional, or national issue of
            public importance to influence a political outcome.
          </Parah>

          <Parah>
            🚫 Products and services that enable dishonest behaviour - Products
            that may infringe upon individual privacy, products that may steal
            other people's personal information, products that may infringe upon
            a third party's properties, products that may steal other people's
            properties, or products or services assisting with falsification.
          </Parah>

          <Parah>
            🚫 Animals - Buying or selling animals, live animals, livestock, and
            pets. Animal body parts/products from rhino, orangutan, elephant, or
            any endangered or threatened animals, including but not limited to
            organs, horns, ivory, bone, skin, fur, wool, leather, or teeth.
            <div>
              Exception:
              <PointsWrapper>
                <PointsIcon />
                Products for animals (toys, clothes, collars, cages, food, etc.){" "}
              </PointsWrapper>
              <PointsWrapper>
                <PointsIcon />
                Pet services like dog walking, pet care, pet cafes, pet
                grooming, training, etc.
              </PointsWrapper>
            </div>
            <Parah>
              Advertising content related to the adoption of animals is
              permitted for NGOs, NPOs, and stray animal shelters (no adoption
              services to be promoted for high breed pets or any invitation to
              join into mix-breeding of pets). services, and immigration
              services.
            </Parah>
          </Parah>

          <Parah>
            🚫 Professional services - Accounting and taxation services, legal
          </Parah>

          <Parah>
            🚫 Pharmaceuticals, healthcare and medicine products - Including any
            pharmacological product claiming health benefits, over-the-counter
            medicines, prescription drugs, vitamins, and powders, shakes or
            gummies claiming to have vitamin or health benefits.
          </Parah>

          <Parah>
            🚫 Financial products or services or opportunities - Including
            foreign exchange, loans, credit cards, buy now pay later services,
            debt consolidation services, investment services, lending and
            management of money assets, trading platforms, pyramid schemes,
            multi-level marketing opportunities, credit repair, bail bonds,
            penny auctions, virtual currencies and “get rich quick” schemes.
          </Parah>

          <Parah>
            🚫 Contraceptive products - Any products, artificial methods, or
            other techniques to prevent pregnancy as a consequence of sexual
            intercourse, such as condoms except for family planning.
          </Parah>

          <Parah>
            🚫 Dating and live video applications or services - Dating services
            are services that are focused on generating connections between
            people who are interested in romance, casual sex, or friendship.
            Live video services are services where the primary feature is a live
            video chat. games that are restricted to certain audiences.
          </Parah>

          <Parah>
            🚫 Age rated films, TV shows and games - Films, TV shows, and
          </Parah>

          <Parah>
            🚫 Other prohibited products or services - International brides,
            hazardous chemical products, trading of human organs and
            transplants, abortion, services of prenatal sex determination,
            protected wildlife, wild flora, and funeral services
          </Parah>
        </Answer>
      </QAWrapper>
    </PageWrapper>
  );
};

export default BrandedPolicy;
